import "./Hint.scss";

import { ComponentProps, FC } from "react";

import Icon from "components/Icon/Icon";
import Text from "components/Text/Text";
import { ClassName } from "config/types";

import classNames from "classnames";

type HintMessageText = Omit<ComponentProps<typeof Text>, "tag"> & {
  tag?: ComponentProps<typeof Text>["tag"];
};

export type HintMessage = {
  text: HintMessageText;
  icon?: ComponentProps<typeof Icon>;
};

interface IProps {
  className?: ClassName;
  hint: HintMessage;
}

const Hint: FC<IProps> = props => {
  const { hint, className } = props;
  const classes = classNames("hint-message__text", className);

  return (
    <div className={classes} data-testid="hint-message">
      {hint.icon && <Icon size="sm" {...hint.icon} />}
      <Text className="hint-message__text-content" tag="p5" as="span" {...hint.text} />
    </div>
  );
};

export default Hint;
